import { Outlet, useMatches } from "react-router-dom";
import { useEffect } from "react";
import config from '../../config';

export default function HeadLayout() {

  type Handle = {
    title?: string;
    description?: string;
    [key: string]: any;
  };

  type MatchWithHandle = {
    handle?: Handle;
    [key: string]: any;
  };

  const matches = useMatches() as MatchWithHandle[];
  const meta = [...matches].reverse()
    .find(m => m.handle && (m.handle.title || m.handle.description));

  useEffect(() => {
    if (!meta?.handle) return;

    /* <title> */
    if (meta.handle.title) {
      document.title =
        "HDB | Change in Flat Ownership | " +
        meta.handle.title +
        (process.env.NODE_ENV !== "production"
          ? ` · ${config.version}`
          : "");
    }

    /* <meta name="description"> */
    if (meta.handle.description) {
      let tag = document.querySelector<HTMLMetaElement>(
        "meta[name='description']"
      );
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = "description";
        document.head.appendChild(tag);
      }
      tag.content = meta.handle.description;
    }
  }, [meta]);

  return <Outlet />;
}